/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { EnrollmentPreviewPatchRequestSetOverrides } from './enrollmentPreviewPatchRequestSetOverrides';

/**
 * Partial update for an existing preview session.
 *
 * At least one of the optional fields must be present (a no-op
 * PATCH is rejected so the route layer doesn't have to second-guess).
 * ``request_seq`` carries the client-side optimistic-update sequence
 * for the spec §16.16 stale-write guard.
 */
export interface EnrollmentPreviewPatchRequest {
  remove_job_candidate_ids?: string[] | null;
  set_overrides?: EnrollmentPreviewPatchRequestSetOverrides;
  request_seq?: number | null;
}
